import type { ReactNode } from "react";
import { useLoginApi } from "~/features/auth/login/components/LoginPopup";
import { OnboardingOverlayProvider } from "~/features/registration/components/Onboarding/OnboardingOverlayProvider";

interface Props {
  children: ReactNode;
  onLoginSuccess: () => void;
}

/**
 * Post-registration auto-login: the onboarding overlay already holds the
 * just-registered credentials, so the login runs directly through the login
 * overlay's form-login hook (`useLoginApi` → OCC credential validator +
 * reverse bridge) — no redirect. `onLoginSuccess` (the header's token-cache
 * clear) runs only after the login actually succeeded.
 */
export const OnboardingAuthenticationProvider = ({ children, onLoginSuccess }: Props) => {
  const { login, errorComponent } = useLoginApi({
    alternativeLoginAction: () => undefined,
  });

  const loginAfterRegistration = async (email: string, password: string) => {
    const loginSucceeded = await login(email, password);
    if (loginSucceeded) {
      onLoginSuccess();
    }
    return loginSucceeded;
  };

  return (
    <OnboardingOverlayProvider loginAfterRegistration={loginAfterRegistration} loginErrorComponent={errorComponent}>
      {children}
    </OnboardingOverlayProvider>
  );
};
